module.exports = __webpack_public_path__ + "img/login-copaamistadiess.0ac9c694.svg";